
export default {
  props: {
    desc: {
      type: String,
      default: "",
    },
    imageUrl: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      shareList: [
        {
          bg: "bg-[#459dff]",
          class: "i-la:facebook-f",
          name: "FaceBook",
        },

        // {
        //   bg: "bg-[#d4247a]",
        //   class: "i-la:instagram",
        //   name: "Instagram",
        // },
        // {
        //   bg: "bg-[#ff0018]",
        //   class: "i-la:youtube",
        //   name: "YouTube",
        // },
        // {
        //   bg: "bg-[#111111]",
        //   url: require("@/static/img/tiktok.png"),
        //   name: "TikTok",
        // },
        {
          bg: "bg-[#00b4ff]",
          class: "i-la:twitter",
          name: "Twitter",
        },
        {
          bg: "bg-[#0076b4]",
          name: "Linkedin",
          class: "i-la:linkedin-in",
        },
        {
          bg: "bg-[#ff0225]",
          class: "i-la:pinterest-p",
          name: "Pinterest",
        },
      ],
    };
  },
  mounted() {
    let pageUrl = window.location.href;
    let pageTitle = document.title;

    let imageUrl = this.imageUrl
      ? `${window.location.origin}${this.imageUrl}`
      : null;

    let urls = {
      FaceBook: `https://www.facebook.com/sharer/sharer.php?kid_directed_site=0&u=${encodeURIComponent(
        pageUrl,
      )}`,
      Twitter: `https://twitter.com/intent/tweet?text=${encodeURIComponent(
        pageTitle,
      )}&url=${encodeURIComponent(pageUrl)}`,
      Linkedin: `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
        pageUrl,
      )}&title=${encodeURIComponent(pageTitle)}`,
      // Instagram: ``,
      // YouTube: ``,
      // TikTok: ``,
      Pinterest: `http://pinterest.com/pin/create/button/?url=${encodeURIComponent(
        pageUrl,
      )}&media=${encodeURIComponent(imageUrl)}&description=${encodeURIComponent(
        this.desc,
      )}`,
    };

    this.shareList = this.shareList.map(item => {
      item.href = urls[item.name] || "#";
      return item;
    });
  },
};
